import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../ui/badge';

export const UrgentBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-red-600 font-semibold text-white">
      {t('component:badge.urgent')}
    </Badge>
  );
};
